import { InvalidStorageFlagsError, InvalidStorageFlagsJSONError } from '../errors';
export var StorageFlagsModel;
(function (StorageFlagsModel) {
    StorageFlagsModel[StorageFlagsModel["None"] = 0] = "None";
    StorageFlagsModel[StorageFlagsModel["Constant"] = 1] = "Constant";
})(StorageFlagsModel || (StorageFlagsModel = {}));
export const hasStorageFlag = (assetType, flag) => (assetType & flag) === flag;
const isStorageFlags = (storageFlags) => StorageFlagsModel[storageFlags] !== undefined;
export const assertStorageFlags = (storageFlags) => {
    if (!isStorageFlags(storageFlags)) {
        throw new InvalidStorageFlagsError(storageFlags);
    }
    return storageFlags;
};
export const toJSONStorageFlags = (type) => assertStorageFlagsJSON(StorageFlagsModel[type]);
const isStorageFlagsJSON = (storageFlags) => StorageFlagsModel[storageFlags] !== undefined;
export const assertStorageFlagsJSON = (type) => {
    if (!isStorageFlagsJSON(type)) {
        throw new InvalidStorageFlagsJSONError(type);
    }
    return type;
};
export const toStorageFlags = (type) => StorageFlagsModel[type];

//# sourceMappingURL=StorageFlagsModel.js.map
